import { AcresMapboxSourceIds } from '@/mapbox-layers';

/**
 * Creates a maplibre style that is google 2d tiles
 *  This gets passed into the map as `mapStyle` and everything on top "just works"
 */
export function createGoogleStyle(sessionData, gmaps_key) {
  const style = {
    layers: [
      {
        id: AcresMapboxSourceIds.GOOGLE_RASTER_TILES,
        source: AcresMapboxSourceIds.GOOGLE_RASTER_TILES,
        type: 'raster',
      },
    ],
    sources: {
      [AcresMapboxSourceIds.GOOGLE_RASTER_TILES]: {
        attribution:
          '&copy; <a href="https://www.google.com">Google</a> contributors',
        maxzoom: 19,
        minzoom: 0,
        tiles: [
          `https://tile.googleapis.com/v1/2dtiles/{z}/{x}/{y}?session=${sessionData.session}&key=${gmaps_key}`,
        ],
        type: 'raster',
      },
    },
    version: 8,
  };
  return style;
}
